import { LEADS_SET_IS_ASSIGNED_TAB } from "../constants";

export function setIsAssignedTabAction( isAssignedValue ) {
    return (dispatch) => {
        dispatch({
            type: LEADS_SET_IS_ASSIGNED_TAB,
            value: isAssignedValue
        })
    }
}
